import { Pill } from '@ics-portal/guardian';
import { type ReactNode } from 'react';
import { ComponentCreateRequestStatusCode } from '@gql/graphql';
import { StatusIcon } from '@pages/notification-components/components/StatusIcon/StatusIcon';

const StatusCodeOrder = [
    ComponentCreateRequestStatusCode.Approved,
    ComponentCreateRequestStatusCode.Forwarded,
    ComponentCreateRequestStatusCode.Replaced,
    ComponentCreateRequestStatusCode.Removed,
];

const SortedStatuses = Object.values(ComponentCreateRequestStatusCode).sort(
    (a, b) => StatusCodeOrder.indexOf(a) - StatusCodeOrder.indexOf(b),
);

interface PillsSummaryProps {
    byStatus: Record<ComponentCreateRequestStatusCode, number>;
}

export function PillsSummary({ byStatus }: PillsSummaryProps): ReactNode {
    return (
        <div className="flex gap-3 flex-wrap">
            {SortedStatuses.map((status) => {
                const id = `pill-${status}`;

                return (
                    <Pill key={id} id={id}>
                        <div className="flex align-items-center gap-2">
                            <StatusIcon
                                id={id}
                                status={status}
                                customTooltipPosition
                            />
                            <h3>{byStatus[status]}</h3>
                        </div>
                    </Pill>
                );
            })}
        </div>
    );
}
